module.exports = __webpack_public_path__ + "static/media/in.f3a60ba3.svg";